type Props = {
  x: string | number;
  y: string | number;
  text: string;
  description?: string;
  fee?: string;
};

export const TickLabel = ({ x, y, text, description, fee }: Props) => (
  <g transform={`translate(${x},${y})`}>
    <text x={0} y={0} dy={16} textAnchor="middle" fill="#666" fontSize={18}>
      {text}
    </text>
    {description && (
      <text x={0} y={0} dy={40} textAnchor="middle" fill="#666" fontSize={16}>
        {description}
      </text>
    )}
    {fee && (
      <text
        x={0}
        y={0}
        dy={60}
        textAnchor="middle"
        fill="#666"
        fontSize={16}
        fontWeight={600}
      >
        {fee}
      </text>
    )}
  </g>
);
